export const PRODUCT_CONSTS = {
    GET_PRODUCTS: "GET_PRODUCTS",
    CREATE_PRODUCT: "CREATE_PRODUCT",
    UPDATE_PRODUCT_BY_ID: "UPDATE_PRODUCT_BY_ID",
    DELETE_PRODUCT_BY_ID: "DELETE_PRODUCT_BY_ID",
    TOGGLE_PRODUCT_VISIBILITY: "TOGGLE_PRODUCT_VISIBILITY",
};
